export { default as HolidaysLoadable } from './HolidaysLoadable';
export { default as HolidaysTRexLoadable } from './HolidaysTRexLoadable';
export { default as HolidaysElfLoadable } from './HolidaysElfLoadable';
export { default as HolidaysPunchLoadable } from './HolidaysPunchLoadable';
export { default as HolidaysListLoadable } from './HolidaysListLoadable';
export { default as HolidaysMoreLoadable } from './HolidaysMoreLoadable';
export { default as HolidaysLightropeLoadable } from './HolidaysLightropeLoadable';



// WEBPACK FOOTER //
// ./src/features/holidays/index.js